class ProductSelector extends HTMLElement {
  constructor() {
    super();
  }

  setProductUrlInLocalStorage() {
    // Get the current value
    const currentStorage = localStorage.getItem('recentlyViewed') ?? '';
    // Add the values to a Set, to avoid duplicates
    const currentStorageSet = new Set(
      currentStorage == '' ? null : currentStorage.split(','),
    );
    // Add the new Element
    currentStorageSet.add(window.location.pathname);

    // Convert the Set into an array
    let storageArray = Array.from(currentStorageSet);

    // Change the currently added element from the last index to the first index
    // in the array
    storageArray.unshift(storageArray[storageArray.length - 1]);
    storageArray.splice(-1);

    localStorage.setItem('recentlyViewed', storageArray.join(','));
  }

  connectedCallback() {
    this.form = document.querySelector(
      `form#${this.getAttribute('data-form-id')}`,
    );
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.submitButton = this.form.elements['add'];
    this.optionLength = Number(
      this.submitButton.getAttribute('data-options-length'),
    );
    this.allOptions = Array.from(
      this.querySelectorAll(
        'fieldset input[type="radio"]:first-of-type, select',
      ),
    );
    this.cartDrawer = document.querySelector('cart-drawer');
    this.variants = JSON.parse(
      this.querySelector('[data-variants-json][type="application/json"]')
        .textContent,
    );
    if (this.variants.length == 1) {
      this.currentVariant = this.variants[0];
    }
    this.prices = JSON.parse(
      this.querySelector('[data-variants-prices]').textContent,
    );
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.addEventListener('click', this.onVariantChange.bind(this));
    this.unavailableText = ` - ${this.dataset.unavailableText}`;

    this.setProductUrlInLocalStorage();

    this.updateOptions();
    this.filterOptions();
  }

  onSubmitHandler(event) {
    event.preventDefault();

    this.submitButton.classList.add('disabled');

    const formData = new FormData(this.form);
    formData.append(
      'sections',
      this.cartDrawer.getSectionsToRender().map((section) => section.section),
    );
    formData.append('sections_url', window.location.pathname);

    Cart.add(formData)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return console.log(response.description);
        }

        this.cartDrawer.renderContents(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.submitButton.classList.remove('disabled');
      });
  }

  handleErrorMessage(errorMessage = false) {
    const errorWrapper = this.closest('section').querySelector(
      '[data-error-wrapper]',
    );
    if (!errorWrapper || !errorMessage) return;

    window.dispatchEvent(
      new CustomEvent('formError', { detail: errorMessage }),
    );
    errorWrapper.classList.toggle('hidden', !errorMessage);

    if (typeof errorMessage == 'string') {
      errorWrapper.textContent = errorMessage || '';
    }
  }

  onVariantChange(event) {
    if (event.target.closest('quantity-input')) return;
    if (event.target.closest('[type="submit"]')) return;

    this.updateOptions();
    this.updateVariant();
    this.handleErrorMessage();
    this.filterOptions();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '');
      this.setUnavailable();
      return;
    }

    if (!this.currentVariant.available) {
      ``;
      this.toggleAddButton(true, window.variantStrings.soldOut);
    }

    this.updateVariantInput();
  }

  formatButtonText(activeIndices, buttonText) {
    // Option index starting from 1.
    let current = 1;

    this.allOptions.forEach((option, index) => {
      if (activeIndices.includes(index)) return;

      // Replacing the current the placeholder with the option name
      buttonText = buttonText.replace(`{{ option${current} }}`, option.name);
      // Increment index to the next placeholder
      current++;
    });

    return buttonText;
  }

  updateButton() {
    let buttonText, attribute;
    const activeIndices = this.options.map((option) => option.index);

    if (
      (activeIndices.length == this.optionLength && activeIndices.length > 0) ||
      (activeIndices.length == 0 && this.optionLength > 0)
    ) {
      attribute = this.currentVariant?.available
        ? 'data-add-to-cart'
        : 'data-sold-out';
    } else {
      attribute = `data-select${activeIndices.length - this.optionLength}`;
    }

    buttonText = this.submitButton.getAttribute(attribute);

    if (activeIndices.length != this.optionLength)
      buttonText = this.formatButtonText(activeIndices, buttonText);

    this.submitButton.innerHTML = buttonText;

    this.submitButton.toggleAttribute(
      'disabled',
      !this.currentVariant?.available,
    );

    if (this.currentVariant)
      this.submitButton.toggleAttribute(
        'css-sold-out',
        !this.currentVariant.available,
      );
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('input[type="radio"]:checked, select'),
      (el, index) => ({ name: el.name, value: el.value, index }),
    );
  }

  updateVariant() {
    if (this.variants.length == 1) return;

    this.currentVariant = this.variants.find((variant) => {
      return !variant.options
        .map((option, index) => this.options[index]?.value === option)
        .includes(false);
    });

    this.currentVariantPrice = this.prices.find((priceObj) => {
      return priceObj.id == this.currentVariant?.id;
    });

    this.updateButton();
  }

  updateVariantInput() {
    const input = this.querySelector('[name="id"]');
    input.value = this.currentVariant.id;
  }

  setUnavailable() {
    return;
  }

  toggleAddButton(disable, text) {
    return;
  }

  renderProductInfo() {
    const params = new URLSearchParams(window.location.search);
    params[params.has('variant') ? 'set' : 'append'](
      'variant',
      this.currentVariant.id,
    );
    params.append('section_id', this.dataset.sectionId);

    fetch(`${this.dataset.url}?${params.toString()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destinationPrice = document.querySelector(
          `#price-${this.dataset.sectionId}`,
        );
        const sourcePrice = html.querySelector(
          `#price-${this.dataset.sectionId}`,
        );

        if (destinationPrice && sourcePrice) {
          destinationPrice.classList.remove('visibility-hidden');
          destinationPrice.innerHTML = sourcePrice.innerHTML;
        }
      });
  }

  /**
   * Filter unavailable options.
   */
  filterOptions() {
    for (const [key, { name }] of this.options.entries()) {
      this.querySelectorAll(`[data-name="${name}"]`).forEach((swatch) => {
        const optionLabel = swatch.nextElementSibling;
        optionLabel.classList.toggle(
          'is-unavailable',
          !this.isOptionAvailable(key, swatch.value),
        );

        updateRotationAngle(optionLabel);
      });
    }
  }

  /**
   * Check if at least one available variant that contains this option exists.
   *
   * @param {Number} index
   * @param {String} value
   * @returns {Boolean}
   */
  isOptionAvailable(index, value) {
    return this.variants.some((variant) => {
      if (!variant.available) return false;

      const valuesToCheck = {};
      for (let i = 0; i < index; i++) {
        const optionHandle = `option${i + 1}`;
        const optionValue = this.options[i].value;
        valuesToCheck[optionHandle] = optionValue;
      }
      const currentHandle = `option${index + 1}`;
      valuesToCheck[currentHandle] = value;
      return Object.entries(valuesToCheck).every(
        ([handle, value]) => variant[handle] === value,
      );
    });
  }
}

customElements.define('product-selector', ProductSelector);
